import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type BookLibraryCollectionService from 'teacher-ui-client/services/book-library/collection'

export default class BookLibraryCollectionIndexRoute extends Route {
  @service('book-library/collection') collectionService!: BookLibraryCollectionService

  model() {
    const bookCollectionsLoader = this.collectionService.loadAllMyCollections.perform({ includeBooks: true })
    return {
      bookCollectionsLoader,
    }
  }
}
